module.exports = __webpack_public_path__ + "images/egslogo.png?71078158a7dcd049f04c24ebc7e40eae";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/egslogo.png
// module id = 341
// module chunks = 0